import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/esm/Accordion";
import AccordionToggle from "./accordion-toggle";
import Details from "./details";
import LessonInformationHeader from "./lesson-information-header";
import { LessonMetadata } from "./lesson-information-modal-types";
import "./lesson-information.scss";
import Resources from "./resources";
import { getStandardCodesForTile } from "./standards";

interface ILessonInformationProps {
  lessonMetadata: LessonMetadata[];
  showStandards: boolean;
  tier1ResourceToken: string;
  isPracticeEnabled: boolean;
}

const LessonInformation = (props: ILessonInformationProps) => {
  const { tier1ResourceToken, lessonMetadata, isPracticeEnabled } = props;
  const [activeKey, setActiveKey] = useState(0);

  const lessonInformationBody = (metadata: LessonMetadata, includeTitle: boolean) => {
    return (
      <div className="lesson-information">
        {includeTitle && (
          <LessonInformationHeader
            title={metadata.name}
            lessonType={metadata.type}
            isPracticeEnabled={isPracticeEnabled}
          />
        )}
        <div className="sections">
          <div className="overview">
            <Details lessonMetadata={metadata} fromAssignmentBuilder={false} />
            {props.showStandards && getStandardCodesForTile(metadata.standardCodes)}
          </div>
          <Resources
            resources={metadata.resources}
            lessonType={metadata.type}
            tier1ResourceToken={tier1ResourceToken}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const activeElement = document.getElementById(`accordion-child-${activeKey}`);
    if (activeElement) activeElement.scrollIntoView();
  }, [activeKey]);

  useEffect(() => {
    const activeElement = document.getElementsByClassName("modal-content")[0];
    if (activeElement) activeElement.scrollTo(0, 0);
  }, []);

  return lessonMetadata.length > 1 ? (
    <Accordion defaultActiveKey={String(activeKey || 0)} data-testid="multi-lesson-dropdown">
      {lessonMetadata.map((metadata, index) => {
        const eventKey: string = String(index);

        return (
          <div key={index} id={`accordion-child-${index}`}>
            <AccordionToggle
              eventKey={eventKey}
              activeKey={`${activeKey}`}
              body={
                <LessonInformationHeader
                  title={metadata.name}
                  lessonType={metadata.type}
                  isPracticeEnabled={isPracticeEnabled}
                />
              }
              callback={(newActiveKey: string) => {
                if (`${activeKey}` !== newActiveKey) {
                  setActiveKey(parseInt(newActiveKey, 10));
                }
              }}
            />
            <Accordion.Collapse eventKey={eventKey}>{lessonInformationBody(metadata, false)}</Accordion.Collapse>
          </div>
        );
      })}
    </Accordion>
  ) : (
    lessonInformationBody(lessonMetadata[0], true)
  );
};

export default LessonInformation;
